module.exports = __webpack_public_path__ + "static/media/pencil-gray.f04e5f60.svg";